import { isEqual } from "lodash";
import { memo, useCallback, useEffect, useState } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Nav.scss";
interface IItem {
  link: string;
  alt: string;
  bgPath: string;
  content: string;
}

const Nav = memo(() => {
  const [list, setList] = useState<IItem[]>([]);
  const getNavList = useCallback(async () => {
    // const res = await fetch(`${preStaticUrl}/json/nav/nav.json`);
    // const data = await res.json();
    setList([
      {
        link: "https://coinmarketcap.com/currencies/zypher-network/",
        alt: "Zypher Network CMC",
        bgPath: "/banners/banner-4.webp",
        content: "/banners/banner-4-content.svg",
      },
      {
        link: "https://ai.zypher.network",
        alt: "AI Mining",
        bgPath: "/banners/banner-1.webp",
        content: "/banners/banner-1-content.svg",
      },
      {
        link: "https://www.theblock.co/press-releases/361116/zypher-network-raises-7-million-to-accelerate-decentralized-trust-for-autonomous-ai-agents",
        alt: "Zypher Network Raises 7M",
        bgPath: "/banners/banner-2.webp",
        content: "/banners/banner-2-content.svg",
      },
      {
        link: "https://pop.zypher.network",
        alt: "Zypher Network POP NFT",
        bgPath: "/banners/banner-3.webp",
        content: "/banners/banner-3-content.svg",
      },
    ]);
  }, []);
  useEffect(() => {
    getNavList();
  }, []);
  return (
    <Swiper
      direction="horizontal"
      loop={true}
      slidesPerView={1}
      spaceBetween={0}
      centeredSlides={true}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
      }}
      pagination={false}
      modules={[Autoplay]}
      className="game_swiper_nav"
    >
      {list.map((v, index) => (
        <SwiperSlide key={index}>
          <div className="nav_item">
            <img src={v.bgPath} className="nav_item_bg" />
            <a
              className={`nav_item_inner nav_item_inner${[index]}`}
              href={v.link}
              target="_blank"
              rel="noreferrer"
            >
              {v.content ? <img src={v.content} className="nav_item_arr" /> : null}
            </a>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}, isEqual);
export default Nav;
